import { Box, ClickableCard, Grid2 as Grid, Typography, useTheme } from "@platform/style";
import * as React from "react";
import { Metrics } from "../models/Metrics";
import { getMetricsCardConfigData } from "../utils/metricsCardConfigData";

interface MetricsCardsProps {
  typeOfWorkItemPage: string;
  metrics: Metrics;
  isLoaded: boolean;
}

export const MetricsCards = ({ typeOfWorkItemPage, metrics, isLoaded }: MetricsCardsProps) => {
  return (
    <Grid container sx={{ pt: "12px" }}>
      <Box style={{ display: "flex", gap: "1rem" }}>
        {getMetricsCardConfigData(typeOfWorkItemPage, metrics, isLoaded, useTheme()).map((metric) =>
          Array.from({ length: metric.count }, (_, index) => (
            <ClickableCard
              key={index}
              elevation={3}
              cardSxProps={() => ({
                border: `1.5px solid`,
                borderColor: metric.borderColor,
                width: "170px",
                height: "55px",
                backgroundColor: metric.bgColor,
              })}
              cardContentSxProps={() => ({
                paddingBottom: 0,
                paddingTop: 1,
                position: "relative",
              })}
            >
              <>
                <Typography variant="h6">
                  <span style={{ whiteSpace: "nowrap" }}>
                    {metric.content[index].value}
                    {metric.icon}
                  </span>
                </Typography>
                <Typography variant="caption">{metric.content[index].caption}</Typography>
              </>
            </ClickableCard>
          ))
        )}
      </Box>
    </Grid>
  );
};
